import {Action, di} from "@dp-instant/core";
import {useState} from "preact/hooks";
import {TypesGame} from "@game/TypesGame";

export const CreateTournamentFormDebug = () => {
    const [state, setState] = useState<{title: string; initialScore: number}>({
        title: "",
        initialScore: 0
    });
    return (
        <form>
            <div>
                <label for="iscore">Initial score:</label>
                <input
                    type="text"
                    id="iscore"
                    name="iscore"
                    value={state.initialScore}
                    onChange={(e: any) =>
                        setState({...state, initialScore: parseInt(e!.currentTarget!.value || 0)})
                    }
                />
            </div>
            <div>
                <label for="ttitle">Title:</label>
                <input
                    type="text"
                    id="ttitle"
                    name="ttitle"
                    onChange={(e: any) => setState({...state, title: e!.currentTarget!.value || 0})}
                />
            </div>
            <a href="#" onClick={() => di.get<Action>(TypesGame.actions.tournamentCreate).run()}>
                {"Create tournament"}
            </a>
        </form>
    );
};
